(function () {
  'use strict';

  var cfg = window.theme && window.theme.lopSingleUnitProducts;
  if (!cfg) return;

  var productIds = new Set((cfg.productIds || []).map(Number));
  var variantIds = new Set((cfg.variantIds || []).map(Number));

  if (!productIds.size) return;

  function isSingleUnitProductId(id) {
    return productIds.has(Number(id));
  }

  function isSingleUnitVariantId(id) {
    return variantIds.has(Number(id));
  }

  function clampQuantity(value) {
    var qty = parseInt(value, 10);
    if (isNaN(qty) || qty < 1) return 1;
    return 1;
  }

  function normalizeSingleUnitCartQuantity(value) {
    var qty = parseInt(value, 10);
    if (isNaN(qty) || qty <= 0) return 0;
    return 1;
  }

  function lockQuantitySelector(selector) {
    if (!selector || selector.dataset.lopSingleUnitLocked === 'true') return;

    var input = selector.querySelector('.qty, input[type="number"]');
    var plus = selector.querySelector('.plus, .pinnacle-quantity-button.increase');
    var minus = selector.querySelector('.minus, .pinnacle-quantity-button.decrease');

    if (!input) return;

    selector.dataset.lopSingleUnitLocked = 'true';
    selector.classList.add('lop-single-unit-qty');

    input.setAttribute('max', '1');
    input.setAttribute('min', '1');
    input.setAttribute('step', '1');
    input.readOnly = true;

    if (plus) {
      plus.disabled = true;
      plus.setAttribute('aria-disabled', 'true');
      plus.tabIndex = -1;
    }

    if (minus) {
      minus.disabled = true;
      minus.setAttribute('aria-disabled', 'true');
      minus.tabIndex = -1;
    }

    input.value = clampQuantity(input.value);
  }

  function lockCartDrawerItem(item) {
    if (!item || item.dataset.lopSingleUnitLocked === 'true') return;

    var productId = Number(item.getAttribute('data-product-id'));
    if (!isSingleUnitProductId(productId)) return;

    item.dataset.lopSingleUnitLocked = 'true';
    item.classList.add('lop-single-unit-item');

    var controls = item.querySelector('.pinnacle-quantity-controls');
    if (controls) lockQuantitySelector(controls);

    var input = item.querySelector('.pinnacle-cart-item-quantity input');
    if (input) {
      input.value = clampQuantity(input.value);
      input.readOnly = true;
    }

    var increase = item.querySelector('.pinnacle-quantity-button.increase');
    if (increase) {
      increase.disabled = true;
      increase.setAttribute('aria-disabled', 'true');
    }

    var decrease = item.querySelector('.pinnacle-quantity-button.decrease');
    if (decrease) {
      decrease.disabled = true;
      decrease.setAttribute('aria-disabled', 'true');
    }
  }

  function applyDomLocks() {
    document.querySelectorAll('[data-lop-single-unit="true"] quantity-selector, .pinnacle-cart-item[data-product-id]').forEach(function (el) {
      if (el.matches('quantity-selector')) {
        lockQuantitySelector(el);
        return;
      }
      lockCartDrawerItem(el);
    });

    document.querySelectorAll('product-form[data-lop-single-unit="true"]').forEach(function (formWrap) {
      var hiddenQty = formWrap.querySelector('input[name="quantity"]');
      if (hiddenQty) hiddenQty.value = '1';
    });
  }

  function enforceCartQuantities(cart) {
    if (!cart || !Array.isArray(cart.items)) return Promise.resolve(cart);

    var fixes = cart.items.filter(function (item) {
      return isSingleUnitProductId(item.product_id) && item.quantity > 1;
    });

    if (!fixes.length) return Promise.resolve(cart);

    return fixes.reduce(function (chain, item) {
      return chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ id: item.key, quantity: 1 })
        }).then(function (response) {
          return response.json();
        });
      });
    }, Promise.resolve(cart));
  }

  function enforceCartFromServer() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        return enforceCartQuantities(cart);
      })
      .catch(function () {});
  }

  function patchFetch() {
    if (window.__lopSingleUnitFetchPatched) return;
    window.__lopSingleUnitFetchPatched = true;

    var originalFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartMutation = /\/cart\/(add|change|update)\.js/.test(url);

      if (!isCartMutation) {
        return originalFetch(input, init);
      }

      var options = init ? Object.assign({}, init) : {};
      var body = options.body;

      if (typeof body === 'string') {
        try {
          var payload = JSON.parse(body);

          if (/\/cart\/add\.js/.test(url)) {
            if (isSingleUnitVariantId(payload.id)) {
              payload.quantity = 1;
              options.body = JSON.stringify(payload);
            }
          }

          if (/\/cart\/change\.js/.test(url)) {
            if (payload.id && payload.quantity != null) {
              var cartItemEl = document.querySelector('[data-line-item-key="' + payload.id + '"]');
              var productId = cartItemEl && Number(cartItemEl.getAttribute('data-product-id'));
              if (productId && isSingleUnitProductId(productId)) {
                payload.quantity = normalizeSingleUnitCartQuantity(payload.quantity);
                options.body = JSON.stringify(payload);
              }
            }
          }
        } catch (e) {}
      }

      return originalFetch(input, options).then(function (response) {
        if (!response.ok || !isCartMutation) return response;

        return response.clone().json().then(function (cart) {
          return enforceCartQuantities(cart).then(function () {
            return response;
          });
        }).catch(function () {
          return response;
        });
      });
    };
  }

  function observeCartDrawer() {
    var drawer = document.getElementById('pinnacle-cart-drawer');
    if (!drawer || drawer.__lopSingleUnitObserver) return;

    var observer = new MutationObserver(function () {
      applyDomLocks();
    });

    observer.observe(drawer, { childList: true, subtree: true });
    drawer.__lopSingleUnitObserver = observer;
  }

  document.addEventListener('DOMContentLoaded', function () {
    patchFetch();
    applyDomLocks();
    observeCartDrawer();
  });

  document.addEventListener('cart:item-added', function () {
    setTimeout(function () {
      enforceCartFromServer().then(applyDomLocks);
    }, 150);
  });

  document.addEventListener('line-item:change:end', function () {
    setTimeout(function () {
      enforceCartFromServer().then(applyDomLocks);
    }, 150);
  });
})();
